import React from 'react';
import { Eye, Facebook, Instagram, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import NewsletterForm from './NewsletterForm';
import useContent from '../hooks/useContent';
import { LLink as Link } from './LocalizedLink';
import { useI18n } from '../context/I18nContext';
import UI from '../lib/uiCatalog';

export default function Footer() {
  const c = useContent();
  const { t } = useI18n();
  const T = (k) => t(k, UI[k]);
  const brand = c.brand_name || 'EasySpanishInsurance';
  return (
    <footer className="footer-bg mt-24">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-9 h-9 rounded-full bg-white/10 inline-flex items-center justify-center">
              <Eye size={18} />
            </span>
            <span className="font-bold text-white text-lg">{brand}</span>
          </div>
          <p className="text-sm text-slate-300 max-w-xs">
            {c.footer_tagline || 'Compare Spanish home and health insurance for non-residents. Independent, English speaking, and built for foreign property owners.'}
          </p>
          <div className="flex items-center gap-3 mt-5">
            {c.social_facebook  && <a href={c.social_facebook}  target="_blank" rel="noreferrer" className="link-quiet"><Facebook size={18} /></a>}
            {c.social_instagram && <a href={c.social_instagram} target="_blank" rel="noreferrer" className="link-quiet"><Instagram size={18} /></a>}
            {c.social_twitter   && <a href={c.social_twitter}   target="_blank" rel="noreferrer" className="link-quiet"><Twitter size={18} /></a>}
            {!c.social_facebook && !c.social_instagram && !c.social_twitter && (
              <>
                <a href="#" className="link-quiet"><Facebook size={18} /></a>
                <a href="#" className="link-quiet"><Instagram size={18} /></a>
                <a href="#" className="link-quiet"><Twitter size={18} /></a>
              </>
            )}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{T('footer.section_insurance')}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="link-quiet" to="/home-insurance">{T('nav.home_insurance')}</Link></li>
            <li><Link className="link-quiet" to="/health-insurance">{T('nav.health_insurance')}</Link></li>
            <li><span className="link-quiet opacity-70">{T('footer.community_soon')}</span></li>
          </ul>
          <h4 className="text-white font-semibold mt-6 mb-3">{T('footer.section_company')}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link className="link-quiet" to="/about">{T('nav.about')}</Link></li>
            <li><Link className="link-quiet" to="/faq">{T('nav.faq')}</Link></li>
            <li><Link className="link-quiet" to="/blog">{T('nav.blog')}</Link></li>
            <li><Link className="link-quiet" to="/contact">{T('nav.contact')}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{T('footer.section_contact')}</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Mail size={16} /> {c.contact_email || 'hello@easyspanishinsurance.com'}</li>
            <li className="flex items-center gap-2"><Phone size={16} /> {c.contact_phone || '+34 951 000 000'}</li>
            <li className="flex items-center gap-2"><MapPin size={16} /> {c.contact_address || 'Marbella, Spain'}</li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">{T('footer.newsletter_title')}</h4>
          <p className="text-sm text-slate-300 mb-3">{T('footer.newsletter_body')}</p>
          <NewsletterForm />
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-5 flex flex-col md:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-400">© {new Date().getFullYear()} {c.footer_copyright || `${brand}. All rights reserved.`}</p>
          <div className="flex items-center gap-5 text-xs text-slate-400">
            <a href="#" className="link-quiet">{T('footer.privacy')}</a>
            <a href="#" className="link-quiet">{T('footer.terms')}</a>
            <a href="#" className="link-quiet">{T('footer.cookies')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
